import { render } from "./ServiceStyleOne.vue?vue&type=template&id=4d451984"
import script from "./ServiceStyleOne.vue?vue&type=script&lang=js"
export * from "./ServiceStyleOne.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\TEMPLATES\\nuron-nft-marketplace-vue-js-template\\nuron-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__